import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TBoardId, TCustomPropertyId } from '../../../../../../../../types/types';
import { confirmDeleteProperty } from '../effects/confirmDeleteProperty';

export const onConfirmDelete = (
    boardId: TBoardId,
    customPropertyId: TCustomPropertyId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(confirmDeleteProperty(boardId, customPropertyId));
    };
    return action;
};
